import React from "react";
import {Route} from "react-router-dom";
import loadable from "../../loadable"

/**
 * @author Yaochao
 * @date 2021/7/15 16:20
 * @description
 */
const MyOrder = loadable(() => import('./myOrder'));
const ProductRenewal= loadable(() => import('./productRenewal'));
const ConfirmAnOrder = loadable(()=>import('./confirmAnOrder'));
const PaymentSuccess = loadable(()=>import('./paymentSuccess'))
class OrderRoute extends React.Component {

    render() {
        return (
            <>
                {/*我的订单*/}
                <Route path={this.props.match.url + "/myOrder"} component={MyOrder}/>
                {/*产品续费*/}
                <Route path={this.props.match.url + "/productRenewal/"} component={ProductRenewal}/>
                {/*确认订单*/}
                <Route path={this.props.match.url + "/confirmAnOrder"} component={ConfirmAnOrder}/>
                {/*支付成功页面*/}
                <Route path={this.props.match.url + "/paymentSuccess"} component={PaymentSuccess}/>
            </>
        )
    }
}

export default OrderRoute